export default __webpack_public_path__ + "static/media/menu-icon-dark.050c552c.svg";